import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withErrorHandling, withLoader } from '@/store/thunks/thunkWrappers';
import { fetchExternalUsersThunk } from '@/store/thunks/externalUsers/fetchExternalUsersThunk';

/**
 * Deletes an external user, then refetches the roster — on the failure path
 * too, so a stale row (e.g. already deleted elsewhere, 404) is cleared while
 * the original error still reaches withErrorHandling for the toast.
 * Refetch-inside-the-thunk follows the deleteSixThunk precedent.
 */
export const deleteExternalUserThunk = createAppAsyncThunk<undefined, string>(
  'externalUsers/deleteExternalUser',
  withLoader(
    withErrorHandling(async (userId, { extra, dispatch }) => {
      try {
        await extra.userService.deleteExternalUser(userId);
      } finally {
        await dispatch(fetchExternalUsersThunk());
      }
      return undefined;
    })
  )
);
